<template>
  <div>
    <div
      v-if="alert.status"
      class="alert alert-dismissible fade show"
      :class="'alert-' + alert.options.type"
      role="alert"
    >
      {{ t(alert.options.message) }}
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-show="module.filter && !module.filter.hideFilter">
      <div
        v-if="module.filter && !module.filter.redirect"
        class="ag-card_tools d-flex justify-content-end"
        :class="filterStatus === true ? 'ag-filter_opened' : ''"
      >
        <div class="ag-filter">
          <button
            @click="setFilterStatus"
            type="button"
            class="d-flex align-items-center"
          >
            <span v-if="module.filter.searchText" class="material-symbols-outlined mr-2">
              tune
            </span>
            <span v-if="!module.filter.searchText" class="material-symbols-outlined mr-2">
              tune
            </span>
            
            {{ t(module.filter.searchText ? "search" : "filter") }}
          </button>
        </div>
        <div class="ag-filter_box">
          <ag-filter
            :module="module.filter"
            :readyToUseFilters="module"
            @search="onSearch"
            v-show="filterStatus"
          ></ag-filter>
        </div>
      </div>
      <div
        v-if="module.filter && module.filter.redirect"
        class="ag-card_tools d-flex justify-content-end"
        :class="filterStatus === true ? 'ag-filter_opened' : ''"
      >
        <div class="ag-filter">
          <button
            @click="redirect(module.filter.redirect)"
            type="button"
            class="d-flex align-items-center"
          >
            <!-- <i class="ag-icon ag-icon_filter mr-2"></i> -->
            {{ t("filter") }}
          </button>
        </div>
      </div>
    </div>
    <div class="ag-content ag-card">
      <div :class="[ 'd-flex align-items-center justify-content-between',
        module.header.buttonPosition,
        { 'ag-card_header': !(module && module.component && module.component.type === 'ag-table' && module.component.options && module.component.options.zebra) }
      ]"
      >
        <ag-policy-navigation
          v-if="module.header.policyNavigation"
          @searchResultFunc="searchResultFunc"
          :key="compKey"
        ></ag-policy-navigation>

        <h6 v-if="module.header.title" class="ag-card_title m-3">
          {{ t(module.header.title) }}
        </h6>

        <!-- Filter Elements -->
        <slot name="cardHeaderFilter"></slot>

        <!-- Breadcrumb -->
        <div v-if="module.header.breadcrumb" class="ag-card_breadcrumb">
          <router-link
            class="d-flex align-items-center"
            v-for="(item, key) in module.header.breadcrumb"
            :to="item.url"
            :key="key"
          >
            <i class="ag-icon ag-icon_breadcrumb mr-1"></i>
            {{ t(item.title) }}
          </router-link>
        </div>

        <!-- Navigation -->
        <div v-if="module.header.navigation" class="ag-card_navigation">
          <ul class="nav">
            <li
              v-for="(item, key) in module.header.navigation"
              class="nav-item d-flex align-items-center"
              :key="key"
            >
              <router-link
                class="nav-item pt-3 pb-3 pl-4 pr-4 d-block d-flex align-items-center"
                :class="
                  ($route.params.param === item.url &&
                    !$route.query.searchResults) ||
                  ($route.fullPath.split('/')[
                    $route.fullPath.split('/').length - 1
                  ] === item.url &&
                    !$route.query.searchResults) ||
                  ($route.fullPath.split('/')[
                    $route.fullPath.split('/').length - 1
                  ] === item.activeUrl &&
                    !$route.query.searchResults) ||
                  (item.selected &&
                    $route.fullPath.split('/')[
                      $route.fullPath.split('/').length - 1
                    ] === item.selected &&
                    !$route.query.searchResults) ||
                  (item.active && !$route.query.searchResults)
                    ? 'active'
                    : ''
                "
                :to="'/' + $route.path.split('/')[1] + '/' + item.url"
                :key="key"
                :id="item.id ? item.id : ''"
                v-if="
                  !item.hideRoles ||
                  (item.hideRoles && item.hideRoles.indexOf(user.role) === -1)
                "
                @click="mainLinkFunc"
              >
                <i
                  :class="`ag-icon ag-icon_${item.icon} mr-1`"
                  v-if="item.icon"
                ></i>
                {{ t(item.title) }}
              </router-link>
              <slot :name="item.navFilter"></slot>
            </li>
            <li
              class="nav-item d-flex align-items-center"
              v-if="module.filter && module.filter.searchResult"
            >
              <router-link
                class="nav-item pt-3 pb-3 pl-4 pr-4 d-block d-flex align-items-center"
                :class="$route.query.searchResults ? 'active' : ''"
                to="?searchResults=true"
                exact
                @click="searchResultFunc"
                activeClass="none"
                exactActiveClass="none"
              >
                {{ t("searchResults") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Tabs -->

        <div v-if="module.header.tabs" class="ag-card_navigation">
          <ul class="nav" id="cardtabs">
            <li v-for="(item, key) in module.header.tabs" :key="key">
              <a
                class="nav-item pt-3 pb-3 pl-4 pr-4 d-block"
                data-toggle="tab"
                :href="'#' + item.url"
                role="tab"
                :aria-controls="item.url"
              >
                {{ t(item.title) }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Quick Search -->
        <div
          class="ag-card_buttons d-flex ml-auto"
          v-if="module.filter.quickSearch"
          :class="{
            'ml-auto mr-3':
              module.component.type == 'ag-table' && module.filter.quickSearch,
          }"
        >
          <div class="input-group">
            <span class="input-group-prepend">
              <div class="input-group-text bg-transparent border-right-0">
                <i class="ag-icon ag-icon_darkSearch"></i>
              </div>
            </span>
            <input
              class="form-control py-2 border-left-0 border"
              type="search"
              placeholder="Search..."
              @input="quickSearch"
              v-model="quickSearchData"
              id="example-search-input"
            />
          </div>
        </div>

        <!-- Buttons -->
        <div
          class="ag-card_buttons d-flex"
          :class="{
            'ml-auto mr-3':
              module.component.type == 'ag-table' &&
              module.component.options.export &&
              !module.filter.quickSearch,
          }"
        >
          <router-link
            v-for="(item, key) in module.header.buttons"
            :key="key"
            :data-target="item.target"
            :data-toggle="item.toggle"
            class="ag-button btn-sm ml-2 d-inline-flex align-items-center"
            :class="'ag-button_' + item.class"
            :to="item.link"
            @click="
              typeof item.function == 'function' ? item.function(module) : ''
            "
          >
            <i class="ag-icon mr-1" :class="'ag-icon_' + item.icon"></i>
            {{ t(item.title) }}
          </router-link>
          <ag-export-button
            v-if="
              module.component.type == 'ag-table' &&
              module.component.options.export
            "
            text="Export"
            @exportstart="exportStart"
            @exportend="exportEnd"
            :data="module.component.options.rows"
            :fileName="module.component.options.export.fileName"
            :columns="module.component.options.columns"
            :headers="module.component.options.columns.map((f) => f.field)"
          />
          <ag-date-select
            v-if="
              module.component.options && module.component.options.dateFilter
            "
            :dateid="'card'"
            :filters="module.filter.filters"
            @onDateChanged="onDateChanged"
          />
          <ag-version-select
            v-if="!$route.query.searchResults && module.filter && module.filter.filterVersion === true"
            :module="module.filter"
            :readyToUseFilters="module"
            :filterVersion="module.filter.filterVersion"
            @onVersionChanged="onVersionChanged"
          />
          <ag-download-button
            v-if="
              module.component.type == 'ag-table' &&
              module.component.options.download
            "
          />
        </div>
      </div>

      <div class="ag-card_body">
        <component
          :is="module.component.type"
          v-if="module.component"
          :options="module.component.options"
          :sortable="module.component.sortable"
           @edit="$emit('edit',$event)"
           @deleteClick="$emit('deleteClick',$event)"
           @copyClick="$emit('copyClick',$event)"
        >
        </component>
        <div v-if="module.header.tabs" class="tab-content" id="cardtabsContent">
          <div
            v-for="(item, key) in module.header.tabs"
            :key="key"
            class="tab-pane fade"
            :id="item.url"
            role="tabpanel"
            :aria-labelledby="item.url"
          >
            <slot :name="item.url"></slot>
          </div>
        </div>
        <slot
          v-if="module.component.type === 'custom' && !module.header.tabs"
          :name="$route.path.split('/').pop()"
        ></slot>
      </div>
    </div>
    <ag-modal
      v-for="(modal, i) in module.modals"
      :key="i"
      :module="modal"
    ></ag-modal>
    <ag-modal
      v-if="module.filter && module.filter.customize"
      :module="module.filter.customize"
    ></ag-modal>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { defineComponent, computed } from "vue";
import AgTable from "@/components/ag-table/index.vue";
import AgFilter from "@/components/ag-filter/index.vue";
import AgModal from "@/components/ag-modal/index.vue";
import AgDateSelect from "@/components/ag-date-select/index.vue";
import AgVersionSelect from "@/components/ag-version-select/index.vue";
import AgExportButton from "@/components/ag-export-button/index.vue";
import AgDownloadButton from "@/components/ag-download-button/index.vue";
import AgPolicyNavigation from "@/components/ag-policy-navigation/index.vue";
import api from "@/store/axiosAgsc";
import moment from "moment";
import { useCommonStore } from "@/stores/common";
import { mapStores } from "pinia";
import { debounce } from "lodash";

export default defineComponent({
  name: "ag-card",
  setup(props) {
    const store = useStore();
    const filterStatus = computed(() => store.getters.filterStatus);
    const alert = computed(() => store.getters.alert);
    const user = computed(() => store.getters.loggedInUser);

    const setFilterStatus = () => {
      let status = store.state.general.filterStatus === true ? false : true;
      store.dispatch(GeneralActionTypes.FILTER_STATUS, status);
      if (status) {
        props.module.filter.filters.forEach((item, index) => {
          if (
            item.data &&
            item.data.length === 0 &&
            item.type !== "wordstyped" &&
            item.source
          ) {
            api.get(item.source, null).then((response) => {
              item.data = response.data.entityData;
            });
          }
        });
      }
    };

    const { t, locale } = useI18n();
    return {
      setFilterStatus,
      filterStatus,
      t,
      locale,
      alert,
      user,
    };
  },
  components: {
    AgModal,
    AgFilter,
    AgTable,
    AgExportButton,
    AgDownloadButton,
    AgDateSelect,
    AgVersionSelect,
    AgPolicyNavigation,
  },
  props: {
    module: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapStores(useCommonStore),
  },
  data() {
    return {
      compKey: 0,
      quickSearchData: null,
    };
  },
  methods: {
    exportStart() {
      this.$emit("export");
    },
    exportEnd() {
      this.$emit("exportend");
    },
    mainLinkFunc() {
      this.$emit("main");
    },
    onSearch() {
      this.$emit("main", "onSearch");
    },
    searchResultFunc() {
      this.$emit("search");
    },
    redirect(url) {
      this.$router.push(url);
    },
    quickSearch: debounce(async function (e) {
      const filter = this.module.component.options;
      filter[this.module.filter.quickSearch] = this.quickSearchData;
      this.module.component.options.fetchTable(this.module.component.options);
    }, 500),
    onDateChanged(date) {
      if (date.value != "custom") {
        const filter = this.module.readyToUseFilters;
        filter.startDate = date.value;
        this.module.readyToUseFilters = filter;
        this.module.component.options.fetchTable(this.module.component.options);
      }
    },
    onVersionChanged(data) {
      if (data.type === "default") {
        this.module.component.options.readyToUseFilters = {
          page: 1,
          policyFileVersion: data.version.start,
          policyFileVersionLimit: data.version.end,
          status: 0,
          startDate: moment()
            .utc()
            .startOf("day")
            .subtract(7, "days")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS"),
          endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
        };
        ++this.compKey;
      } else if (data.type === "interval") {
        this.module.component.options.readyToUseFilters = {
          page: 1,
          startDate:
            data && data.data && data.data.value
              ? moment(data.data.value).utc().format("YYYY-MM-DDTHH:mm:ss.SSS")
              : moment()
                  .startOf("day")
                  .subtract(7, "days")
                  .utc()
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
          endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
          status: 0,
        };

        if (
          this.commonStore.dateFilter &&
          this.commonStore.dateFilter.label === "Custom Range"
        ) {
          this.module.component.options.readyToUseFilters.startDate = moment(
            this.commonStore.dateFilter.value
          )
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS");
          this.module.component.options.readyToUseFilters.endDate = moment(
            this.commonStore.dateFilter.endDate
          )
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS");
        }
        ++this.compKey;
      }
      this.module.component.options.fetchTable(
        this.module.component.options,
        data.type
      );
    },
  },
});
</script>

<style scoped></style>
